import CloseIcon from "@mui/icons-material/Close";
import { IconButton, SxProps, Theme } from "@mui/material";

type ModalCloseButtonProps = {
  onClick: () => void;
  label?: string;
  sx?: SxProps<Theme>;
};

const ModalCloseButton = ({
  onClick,
  label = "Close",
  sx,
}: ModalCloseButtonProps) => (
  <IconButton
    aria-label={label}
    onClick={onClick}
    size="small"
    sx={[
      {
        color: "#344054",
        "&:hover": { backgroundColor: "#E20505", color: "#fff" },
      },
      ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
    ]}
  >
    <CloseIcon fontSize="small" />
  </IconButton>
);

export default ModalCloseButton;
